import { FloatingInfoCard } from './FloatingInfoCard';

export type OnboardingStepKey = 'trigger' | 'incentive';

const ONBOARDING_STEPS: Record<OnboardingStepKey, { title: string; body: string; imageSrc: string }> = {
  trigger: {
    title: 'What is a Trigger?',
    body: 'Triggers are project-defined actions that are executed when users perform significant events.',
    imageSrc: '/assets/webp/onboarding-1.webp',
  },
  incentive: {
    title: 'What makes an incentive?',
    body: 'An incentive is a reward distribution that you create to motivate specific behaviors. You can reward users with tokens or points, pay out to end users or their referrals, and include multiple triggers in a single incentive.',
    imageSrc: '/assets/webp/onboarding-2.webp',
  },
};

const DEFAULT_STEPS: OnboardingStepKey[] = ['trigger', 'incentive'];

interface OnboardingTutorialProps {
  storageKey: string;
  title?: string;
  steps?: OnboardingStepKey[];
}

export const OnboardingTutorial = ({ storageKey, title = '', steps = DEFAULT_STEPS }: OnboardingTutorialProps) => {
  const selectedSteps = steps.map((key) => ONBOARDING_STEPS[key]);
  return <FloatingInfoCard title={title} steps={selectedSteps} storageKey={storageKey} />;
};
